import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LinkListGroupItem } from '@mwe/models';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-link-list-group',
  templateUrl: './link-list-group.component.html',
  imports: [BasicCardComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkListGroupComponent {
  items = input<LinkListGroupItem[]>();
}
